import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is supplied by the host
import axios from '@utils/axios';

import { Maybe } from 'types/UtilityTypes';
import { ApiError } from 'types/api/ApiError';

import { toApiError } from './toApiError';

export type CloneLineage = {
  sourceLoadId: number;
  sourceLoadIdentifier: string;
};

export async function fetchCloneLineage(
  loadId: number
): Promise<Result<Maybe<CloneLineage>, ApiError>> {
  try {
    const response = await axios.get<Maybe<CloneLineage>>(
      `/load/${loadId}/clone-lineage`
    );
    return ok(response.data);
  } catch (error) {
    return err(toApiError(error, 'Unable to load clone history.'));
  }
}
